// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoDocs_wrapper__3sFuu"};